import { JoynV2Api } from '../api/joyn/JoynApi';

export default new (class ChurnReasonRepository {
  getChurnReasons = () => JoynV2Api.get(`/sammy/churn-reasons`);
})();
